module.exports = __webpack_public_path__ + "static/img/s_2.e2142a50.png";